import { defineStore } from 'pinia'
import { ref } from 'vue'
import api from '@/utils/axios'

export interface SiteSettings {
  hero_title: string
  hero_subtitle: string
  footer_copyright: string
}

export const defaultSiteSettings: SiteSettings = {
  hero_title: 'Взяти участь у розіграші',
  hero_subtitle: 'Заповніть реєстраційну форму',
  footer_copyright: '© 2025 Samsung. All rights reserved.'
}

export const useSiteSettingsStore = defineStore('siteSettings', () => {
  const settings = ref<SiteSettings>({ ...defaultSiteSettings })
  const loading = ref(false)
  const saving = ref(false)
  const error = ref('')

  const fetchSiteSettings = async () => {
    try {
      loading.value = true
      error.value = ''
      const response = await api.get('/api/site-settings')
      settings.value = {
        ...defaultSiteSettings,
        ...response.data
      }
    } catch (fetchError: any) {
      error.value = fetchError.response?.data?.message || 'Failed to fetch site settings'
      console.error('Failed to fetch site settings:', fetchError)
    } finally {
      loading.value = false
    }
  }

  const updateSiteSettings = async (siteSettings: SiteSettings) => {
    try {
      saving.value = true
      error.value = ''
      const response = await api.put('/api/site-settings', siteSettings)
      settings.value = {
        ...defaultSiteSettings,
        ...response.data
      }
      return { success: true, settings: settings.value }
    } catch (saveError: any) {
      const message = saveError.response?.data?.message || 'Failed to update site settings'
      error.value = message
      return {
        success: false,
        error: message
      }
    } finally {
      saving.value = false
    }
  }

  return {
    settings,
    loading,
    saving,
    error,
    fetchSiteSettings,
    updateSiteSettings
  }
})
